import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  getAlumnosUsuarioSuccess,
  GET_ALUMNOS_USUARIO,
  SWITCH_PAYMENT_STATUS,
  SWITCH_CONTRACT_STATUS,
  SWITCH_STUDENT_STATUS,
} from "../../redux/actions/matriculaActions";
import {
  CICLO_LECTIVO_A_MATRICULAR,
  CICLO_LECTIVO_A_MATRICULAR_SOLO_ANIO,
  ROUTE_ALUMNO,
  ROUTE_NUCLEO,
  ROUTE_NOTIFICACION,
  ROUTE_MATRICULA,
  ROUTE_CATALOGO,
  programaToCorreo,
} from "../../utils/constants";
import toAPIPath from "../../utils/locationResolver";
import { concatenarNombreAlumno } from "../../utils/stringUtils";
import { buildSwitchContractInternalNotificationEmail, buildSwitchContractNotificationEmail } from "../../utils/emailTemplates";

export function* loadAlumnos(payload) {
  const { api, userData } = payload;
  try {
    const skip = userData.page * userData.pageSize;
    const limit = userData.pageSize;
    if (userData.isAdmin) {
      const total = yield call(
        api.get,
        toAPIPath([
          ROUTE_ALUMNO,
          `count?where=${encodeURIComponent(
            `{ "or": [${userData.nameLetter
              ? `{"nombreAlumno": { "like":"^${userData.nameLetter}.*","options":"i"}}`
              : `{"nombreAlumno": { "like":".*${userData.nameFilter}.*","options":"i"}}, {"apellido1": { "like":".*${userData.nameFilter}.*","options":"i"}}, {"apellido2": { "like":".*${userData.nameFilter}.*","options":"i"}}`
            }] }`
          )}&access_token=${userData.token}`,
        ])
      );
      const alumnos = yield call(
        api.get,
        toAPIPath([
          `${ROUTE_ALUMNO}?filter=${encodeURIComponent(
            `{"where":{ "or": [${userData.nameLetter
              ? `{"nombreAlumno": { "like":"^${userData.nameLetter}.*","options":"i"}}`
              : `{"nombreAlumno": { "like":".*${userData.nameFilter}.*","options":"i"}}, {"apellido1": { "like":".*${userData.nameFilter}.*","options":"i"}}, {"apellido2": { "like":".*${userData.nameFilter}.*","options":"i"}}`
            }] }, "order": "nombreAlumno ASC", "limit": ${limit}, "skip": ${skip} }`
          )}&access_token=${userData.token}`,
        ])
      );
      yield put(getAlumnosUsuarioSuccess(alumnos, total.count));
    } else {
      const total = yield call(
        api.get,
        toAPIPath([
          ROUTE_ALUMNO,
          `count?where=${encodeURIComponent(
            `{ "nucleo": "${userData.nucleo}" }`
          )}&access_token=${userData.token}`,
        ])
      );
      const nucleo = yield call(
        api.get,
        toAPIPath([
          ROUTE_NUCLEO,
          `${userData.nucleo}?filter=${encodeURIComponent(
            `{"include":{"relation":"alumno", "limit": ${limit}, "skip": ${skip}, "scope": { "order": "nombreAlumno" } }}`
          )}&access_token=${userData.token}`,
        ])
      );
      yield put(getAlumnosUsuarioSuccess(nucleo.alumno, total.count));
    }
  } catch (err) {
    throw err;
  }
}

export function* switchPaymentStatus(payload) {
  const { api, id, pendientePago, token } = payload;
  try {
    yield call(
      api.patch,
      toAPIPath([ROUTE_ALUMNO, `${id}?access_token=${token}`]),
      {
        pendientePago,
      }
    );
    window.location.reload();
  } catch (err) {
    throw err;
  }
}

export function* switchStudentStatus(payload) {
  const { api, alumno, activo, token } = payload;
  try {
    yield call(
      api.patch,
      toAPIPath([ROUTE_ALUMNO, `${alumno}?access_token=${token}`]),
      {
        inactivo: activo,
      }
    );
    window.location.reload();
  } catch (err) {
    throw err;
  }
}

export function* switchContractStatus(payload) {
  const { api, alumno, token } = payload;
  try {
    const appState = yield select((state) => state.app);

    const usuarioId = appState.session.user.id;
    const usuario = appState.session.user.nombre;

    const nucleoData = yield call(
      api.get,
      toAPIPath([
        ROUTE_NUCLEO,
        `${alumno.nucleo}?filter=${encodeURIComponent(
          '{"include": [{"relation":"encargado"}]}'
        )}&access_token=${token}`,
      ])
    );

    const encargadosEmails = nucleoData.encargado.map((e) => e.email);

    const matricula = {
      usuario: usuarioId,
      alumno: alumno.id,
      nucleo: alumno.nucleo,
      cicloLectivo: CICLO_LECTIVO_A_MATRICULAR_SOLO_ANIO,
      nivel: alumno.nivel,
      nombreAlumno: concatenarNombreAlumno(alumno),
      fecha: new Date(),
      formulario: `Contrato Servicios Educativos ${CICLO_LECTIVO_A_MATRICULAR} físico`,
    };
    yield call(
      api.post,
      toAPIPath([`${ROUTE_MATRICULA}?access_token=${token}`]),
      matricula
    );

    yield call(
      api.patch,
      toAPIPath([ROUTE_ALUMNO, `${alumno.id}?access_token=${token}`]),
      {
        estadoMatricula: `Matrícula ${CICLO_LECTIVO_A_MATRICULAR} Completa`,
      }
    );

    /* eslint-disable no-irregular-whitespace, max-len */
    const notificacionUsuario = buildSwitchContractNotificationEmail(alumno, encargadosEmails.join(","), usuario);
    yield call(
      api.post,
      toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]),
      notificacionUsuario
    );

    const catalogo = yield call(
      api.get,
      toAPIPath([ROUTE_CATALOGO, `findOne?access_token=${token}`])
    );

    const programa = Object.keys(catalogo.programas).find(
      (p) => catalogo.programas[p].niveles.indexOf(alumno.nivel) > -1
    );

    const correoCoordinacion = programaToCorreo[programa] || "";

    const notificacionWeizman = buildSwitchContractInternalNotificationEmail(alumno, `direccion.general@weizmancr.net, contabilidad@weizmancr.net, direccion.adm.fin@weizmancr.net, asistente.direccion@weizmancr.net, recepcion@weizmancr.net, asistente.contable@weizmancr.net, proveeduria@weizmancr.net, informatica@weizmancr.net, enfermeria@weizmancr.net, coordinacion.bienestar.escolar@weizmancr.net${correoCoordinacion ? `, ${correoCoordinacion}` : ""}`);

    yield call(
      api.post,
      toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]),
      notificacionWeizman
    );

    window.location.reload();
  } catch (err) {
    throw err;
  }
}

export default function* rootSaga() {
  yield takeLatest(GET_ALUMNOS_USUARIO, loadAlumnos);
  yield takeLatest(SWITCH_PAYMENT_STATUS, switchPaymentStatus);
  yield takeLatest(SWITCH_CONTRACT_STATUS, switchContractStatus);
  yield takeLatest(SWITCH_STUDENT_STATUS, switchStudentStatus);
}
